import { GET_ADMIN_INTEGRATION_LOGS, GET_ADMIN_INTEGRATION_LOGS_ERROR, GET_ADMIN_INTEGRATION_LOGS_SUCCESS } from "./actionTypes"

export const getAdminIntegrationLogs = (payload) => {
  return {
    type: GET_ADMIN_INTEGRATION_LOGS,
    payload: payload
  }
}

export const getAdminIntegrationLogsSuccess = (templates, meta = {}) => {
  return {
    type: GET_ADMIN_INTEGRATION_LOGS_SUCCESS,
    payload: templates,
    meta,
  }
}

export const getAdminIntegrationLogsError = error => {
  return {
    type: GET_ADMIN_INTEGRATION_LOGS_ERROR,
    payload: error,
  }
}
